import Cookies from 'js-cookie';

export const setAuthToken = function (token: string, daysToExpire?: number) {
    Cookies.set('token', token, { expires: daysToExpire, secure: true });
}

export const setDebugToken = function () {
    if (process.env.REACT_APP_DEBUG_JWT !== undefined) {
        setAuthToken(process.env.REACT_APP_DEBUG_JWT);
    }
}

export const getAuthToken = function (): string | null {
    let token = Cookies.get('token');
    if (token)
        return token;
    return null;
}